module.exports = __webpack_public_path__ + "img/647171_1F3349_2A475C_87A5AD-256px.62ca5e98.png";